const en = {
  nav: {
    home: "Home",
    about: "About",
    services: "Toll Manufacturing",
    products: "Products",
    articles: "Articles",
    gallery: "Gallery",
    faq: "FAQ",
    contact: "Contact",
    orderSample: "Order Sample",
    career: "Career",
    live: "Live",
    consult: "Free Consultation",
    startMaklon: "Start Manufacturing!",
    more: "More",
  },
  common: {
    chatWhatsApp: "Chat on WhatsApp",
    sendMessage: "Send Message",
    learnMore: "Learn more",
    loading: "Loading...",
    filterAll: "All",
    share: "Share:",
    readMinutes: "{n} min read",
    backHome: "Back to Home",
    consultWa: "Consult via WhatsApp",
    close: "Close",
    announcement: "Announcement",
    promo: "Promo",
    location: "Location",
  },
  footer: {
    company: "Company",
    help: "Help",
    contact: "Contact",
    aboutUs: "About Us",
    whatsappUs: "WhatsApp Us",
    rights: "All Rights Reserved.",
    servicesLine: "Functional Powder Drink Toll Manufacturing · Private Label · OEM · ODM · Contract Manufacturing",
    taglineFallback: "Quality functional powder drink manufacturing — a strategic partner for Indonesian F&B brands in innovation, quality, and growth.",
  },
  home: {
    seoTitle: "Trusted Functional Powder Drink Manufacturer",
    seoDesc: "PT Mandala Cahaya Sentosa — functional powder drink toll manufacturing, private label, OEM, ODM & contract manufacturing since 2008. Affordable MOQ, BPOM & Halal.",
    badge: "Trusted Manufacturer Since 2008",
    titleBefore: "Build Your Dream ",
    titleHighlight: "Beverage Brand",
    titleAfter: " With Us",
    lead: "From idea to market-ready product, PT Mandala Cahaya Sentosa is a trusted functional powder drink manufacturing partner for innovation, quality, and F&B business growth in Indonesia.",
    ctaCatalog: "View Product Catalog",
    statYears: "Years of Experience",
    statBrands: "Client Brands",
    statSince: "Established Since 2008",
    statLegal: "BPOM, Halal & ISO",
    heroSubtitle: "From Product Idea to Market Ready",
    statFormulas: "Successful Formulas",
    statProducts: "Products Launched",
    certsOverline: "Certified & Trusted",
    servicesOverline: "Our Services",
    servicesTitle: "End-to-End Solutions for Your Beverage Brand",
    servicesSubtitle: "We understand your challenges: complex formulations, high factory costs, and lengthy BPOM & Halal processes. Mandala delivers an end-to-end solution that turns ideas into sellable products.",
    whyOverline: "Why Choose Us",
    whyTitleBefore: "Why do hundreds of brands trust ",
    whyTitleHighlight: "Mandala Cahaya Sentosa",
    whyTitleAfter: "?",
    whyBody: "Over a decade of experience and a commitment to quality make us the partner of choice for functional powder drink brands in Indonesia.",
    whyCta: "More About Us",
    processOverline: "Our Process",
    processTitle: "5 Simple Steps to a Market-Ready Product",
    processSubtitle: "We designed a transparent, structured workflow so you always know where your product stands.",
    productsOverline: "Product Categories",
    productsTitle: "Our Featured Products",
    productsSubtitle: "A wide range of functional powder drinks you can manufacture with custom formulations for your brand.",
    seeAllProducts: "See All Products",
    productDetail: "Product Details",
    testimonialsOverline: "Client Testimonials",
    testimonialsTitle: "Trusted by Hundreds of Brands in Indonesia",
    ctaOverline: "Ready to Start?",
    ctaTitle: "Interested in Our Beverage Manufacturing Services?",
    ctaBody: "Contact our marketing team for a free consultation. We're ready to help bring your beverage brand to life.",
    services: [
      { title: "Powder Drink Manufacturing", desc: "Create health, beauty, or functional beverage products with exclusive formulas and quality ingredients." },
      { title: "Private Label", desc: "Private label solutions for your brand with market-proven standard formulations." },
      { title: "Contract Manufacturing", desc: "Large-scale manufacturing with high quality standards. Consistent taste & packaging guaranteed." },
      { title: "OEM & ODM", desc: "Full service from formula design to market-ready packaging tailored to your brand specs." },
      { title: "Research & Development", desc: "Experienced R&D team developing innovative formulas aligned with trends and target markets." },
      { title: "Regulatory Consulting", desc: "Support for BPOM permits, Halal MUI certification, and all product legalities." },
    ],
    advantages: [
      { title: "Affordable MOQ", desc: "Starting from 1,000 boxes — ideal for startups & SMEs." },
      { title: "Complete Legal Support", desc: "We handle BPOM & Halal MUI until completion." },
      { title: "Free Consultation", desc: "Discuss your beverage product idea with no upfront cost." },
      { title: "Fast Production", desc: "Efficient process with high standards — ready to launch sooner." },
      { title: "Expert R&D Team", desc: "1,000+ successful formulas aligned with Indonesian market trends." },
      { title: "Guaranteed Samples", desc: "Free sample trials until they match your requirements." },
    ],
    process: [
      { t: "Consultation & Product Idea", d: "Share your idea or needs. Our team analyzes trends, formulas, and market opportunities." },
      { t: "Formulation & Samples", d: "R&D develops samples to your brief, then ships them for testing & approval." },
      { t: "Design & Legalities", d: "Free packaging design for your brand, plus BPOM & Halal processing." },
      { t: "Production & Quality Check", d: "Mass production in a high-standard facility, packed, and rigorously quality-checked." },
      { t: "Product Delivery", d: "Products shipped on time to your location — ready for market." },
    ],
  },
  about: {
    seoTitle: "About Us",
    seoDesc: "Established since 2008, PT Mandala Cahaya Sentosa is a trusted functional powder drink manufacturing partner in Indonesia with BPOM, Halal, GMP, HACCP, ISO 9001 & ISO 22000 certifications.",
    overline: "About Us",
    heroTitle: "Over 10 Years as a Trusted Partner for Indonesian F&B Brands",
    heroLead: "PT Mandala Cahaya Sentosa is a functional powder drink manufacturing company dedicated to being a strategic partner for F&B entrepreneurs — from startups to multinational companies.",
    storyOverline: "Our Story",
    storyTitle: "From Idea to Market-Ready Product",
    storyP1: "Founded in 2008, Mandala Cahaya Sentosa has grown into one of Indonesia's trusted functional powder drink manufacturers. We support every stage of our clients' product journey: initial consultation, custom formulation, sampling, BPOM & Halal legalities, through mass production and delivery.",
    storyP2: "With high-standard production facilities (GMP, HACCP, ISO 9001, ISO 22000) and an experienced R&D team, we have created over 1,000 unique formulas across functional powder drinks, collagen, coffee, tea, chocolate, and traditional herbal categories.",
    storyP3: "Our vision is to become a leading national and international company in food, beverages, and traditional supplements.",
    imgAlt: "Mandala Factory",
    valuesOverline: "Vision Mission Values",
    valuesTitle: "Our Foundation",
    vision: "Vision",
    visionDesc: "To become a leading national and international company in food, beverages, and traditional supplements.",
    mission: "Mission",
    missionDesc: "To provide functional beverage manufacturing services.\nTo prioritize quality in every action and process.\nTo develop new product innovations in line with public trends while maintaining food safety.\nTo enhance employees’ skills and knowledge for maximum operational performance.\nTo expand the business network through strategic locations in order to become the best in Indonesia.",
    values: "Values",
    valuesDesc: "Integrity, Innovation, Quality, Client Trust, and Collaboration guide every interaction.",
    certOverline: "Certifications",
    certTitle: "World-Class Quality Standards",
    certSubtitle: "All certifications that ensure the quality, safety, and credibility of the powder drinks we produce.",
    certs: [
      { c: "BPOM", d: "Indonesian FDA" },
      { c: "HALAL", d: "MUI Indonesia" },
      { c: "GMP", d: "Good Manufacturing Practice" },
      { c: "HACCP", d: "Hazard Analysis" },
      { c: "ISO 9001", d: "Quality Management" },
      { c: "ISO 22000", d: "Food Safety" },
    ],
    ctaTitle: "Ready to collaborate with us?",
    ctaBody: "Discuss your beverage product concept with our expert team.",
  },
  services: {
    seoTitle: "Powder Drink Manufacturing Services",
    seoDesc: "Full services: powder drink manufacturing, private label, OEM/ODM, contract manufacturing, R&D, and BPOM & Halal legal support for Indonesian F&B brands.",
    overline: "Manufacturing Services",
    heroTitle: "Complete Solutions to Launch Your Beverage Brand",
    heroLead: "From standard manufacturing and private label to OEM/ODM and large-scale contract manufacturing — all under one roof with high quality standards.",
    items: [
      { title: "Powder Drink Manufacturing", desc: "Complete manufacturing for functional powder drink categories. We help from formula research to mass production.", bullets: ["Custom formulation to brief", "MOQ from 1,000 boxes", "Free packaging design", "BPOM & Halal support"] },
      { title: "Private Label", desc: "A fast path to build your beverage brand using market-proven standard formulas.", bullets: ["Ready-stock formulas", "Fast time to market", "Minimal investment", "Custom branding"] },
      { title: "OEM & ODM", desc: "Original Equipment / Design Manufacturing for brands that want full control over product specs.", bullets: ["Custom formulation", "Custom packaging design", "Formula confidentiality (NDA)", "Strict quality control"] },
      { title: "Contract Manufacturing", desc: "Large-scale production with high quality standards. Ideal for brands ready to scale.", bullets: ["Large production capacity", "Consistent quality", "Cost efficiency", "Long-term contracts"] },
      { title: "Research & Development", desc: "Our R&D team develops innovative formulas aligned with market trends and your target consumers.", bullets: ["1,000+ successful formulas", "Trend analysis", "Sample development", "Stability & sensory testing"] },
      { title: "Legal & Certification", desc: "We help handle all product legalities until ready for the Indonesian market.", bullets: ["BPOM MD / TR", "Halal MUI certification", "Barcode & retail labels", "Full accompaniment"] },
    ],
  },
  products: {
    seoTitle: "Powder Drink Product Catalog",
    seoDesc: "Powder drink products you can manufacture: Collagen, Coffee, Herbal, Fiber, Chocolate, Ice Cream, Milkshake, and other custom formulations.",
    overline: "Our Products",
    heroTitle: "Powder Drink Catalog You Can Manufacture",
    heroLead: "All products can be customized for formulation, flavor, packaging, and your target market.",
    detail: "Product Details",
    empty: "No products in this category yet.",
    notFound: "Product not found.",
    back: "Back to Products",
    benefits: "Benefits & Features",
    specs: "Specifications",
    related: "Other Products",
    waInterest: "Hi, I'm interested in the product *{name}* on mandala.co.id. Please share more details.",
  },
  articles: {
    seoTitle: "Articles & Insights",
    seoDesc: "Articles on powder drink industry trends, F&B brand-building tips, BPOM & Halal legalities, and manufacturing insights from PT Mandala Cahaya Sentosa.",
    overline: "Articles",
    heroTitle: "Beverage Industry Articles & Insights",
    heroLead: "Tips, trends, and practical guides to help your powder drink business grow.",
    readMore: "Read More",
    empty: "No articles yet.",
    notFound: "Article not found.",
    back: "Back to Articles",
    related: "Related Articles",
  },
  gallery: {
    seoTitle: "Gallery",
    seoDesc: "Staff, R&D, Production, and Event documentation from PT Mandala Cahaya Sentosa.",
    overline: "Gallery",
    heroTitle: "Facilities & Event Gallery",
    heroLead: "Albums: Staff, Rnd, Production, and Event — including YouTube & Instagram highlights.",
    empty: "No photos yet.",
  },
  faq: {
    seoTitle: "Frequently Asked Questions (FAQ)",
    seoDesc: "Complete answers about powder drink manufacturing: MOQ, production time, custom formulas, BPOM & Halal certification, and how to start working with us.",
    overline: "FAQ",
    heroTitle: "Frequently Asked Questions",
    heroLead: "Have questions about our beverage manufacturing services? Check this FAQ list — the answer may already be here.",
    empty: "No FAQs yet.",
    stillTitle: "Still have questions?",
    stillBody: "Our team is ready to help via WhatsApp or a direct message.",
  },
  contact: {
    seoTitle: "Contact Us",
    seoDesc: "Free consultation with PT Mandala Cahaya Sentosa's marketing team. We help bring your powder drink brand from idea to market-ready product.",
    overline: "Contact Us",
    heroTitle: "Let's Discuss Your Dream Product",
    heroLead: "Fill out the form below and the Mandala team will contact you for a free consultation.",
    infoTitle: "Contact Information",
    infoLead: "Connect directly with our marketing team.",
    address: "Factory Address",
    phone: "Phone / WhatsApp",
    email: "Email",
    hours: "Business Hours",
    formTitle: "Send a Message",
    formHint: "All fields except those marked (*) are optional.",
    name: "Full Name *",
    emailField: "Email",
    whatsapp: "WhatsApp Number",
    company: "Company / Brand Name",
    productPlan: "Product Plan",
    productPlaceholder: "Example: Collagen drink sachet 15g",
    message: "Message *",
    sending: "Sending...",
    errorRequired: "Name and message are required",
    success: "Your message has been sent. We will contact you shortly.",
    errorSend: "Failed to send message",
  },
  notFound: {
    seoTitle: "Page Not Found",
    title: "Page Not Found",
    body: "The page you are looking for is unavailable or has been moved.",
  },
  orderSample: {
    seoTitle: "Order Powder Drink Sample",
    seoDesc: "Order a powder drink sample from PT Mandala Cahaya Sentosa. Fee Rp 100,000 per formula, 100 grams (4–5 sachets), one free revision.",
    overline: "Order Sample",
    title: "Powder Drink Sample Production",
    lead: "Test your brand formula before mass production. Samples are packed in practical sachets.",
    imgAlt: "Mandala powder drink product sample",
    termsTitle: "Sample Terms",
    terms: [
      "Fee Rp 100,000 per formula",
      "You receive 100 grams, consisting of 4–5 sachets at 20–25 grams each",
    ],
    freeBadge: "Free Revision",
    freeNote: "If the first sample is not quite right, you can get 1 Sample Revision for FREE, with no extra charge.",
    cta: "Order Sample via WhatsApp",
  },
  career: {
    seoTitle: "Careers",
    seoDesc: "Job vacancy posters from PT Mandala Cahaya Sentosa.",
    overline: "Careers",
    title: "Job Openings",
    lead: "Latest vacancy posters from PT Mandala Cahaya Sentosa.",
    empty: "No job openings have been published yet.",
  },
  live: {
    seoTitle: "Live",
    seoDesc: "Watch PT Mandala Cahaya Sentosa YouTube & TikTok lives.",
    overline: "Live",
    title: "Mandala Live",
    lead: "Watch the latest lives and past archives from YouTube & TikTok.",
    empty: "No lives have been published yet.",
    openYoutube: "Open on YouTube",
    openTiktok: "Open on TikTok",
  },
  popup: {
    defaultButton: "Learn More",
  },
};

export default en;
